module.exports = __webpack_public_path__ + "img/FlashStation FS3600.d24b008e.png";